import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { FaqAccordion } from '../components/shared/FaqAccordion';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
import { whatsappLink } from '../utils/whatsapp';
export function FaqPage() {
  const {
    t,
    lang
  } = useLanguage();
  const f = t.faq;
  useSeo({
    ...t.common.seo.faq,
    lang
  });
  return <main data-id="element-458" data-mp="371qlut0kt03b">
      <PageHeader eyebrow={f.eyebrow} title={f.title} description={f.description} data-id="element-459" data-mp="3717axw9cfbys" />
      <section className="bg-white py-14 sm:py-20" data-id="element-460" data-mp="324743j4o656m">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12" data-id="element-461" data-mp="321ky3nxffxqi">
          <div className="lg:col-span-8" data-id="element-462" data-mp="3grjwnrsw9b6i">
            <FaqAccordion items={f.items} searchable idPrefix="faq" data-id="element-463" data-mp="3bsp1dqdqpu5i" />
          </div>
          <aside className="lg:col-span-4" data-id="element-464" data-mp="3pszvr3e9dqvf">
            <div className="rounded-2xl bg-mauve-deep p-8 text-white lg:sticky lg:top-28" data-id="element-465" data-mp="3ptt4ub0owsgq">
              <h2 className="font-display text-2xl font-semibold" data-id="element-466" data-mp="3lsfvvs2aw95l">{f.stillHelp}</h2>
              <p className="mt-3 text-sm leading-relaxed text-white/80" data-id="element-467" data-mp="2658es9dfwhlt">{t.contact.info.online}</p>
              <a href={whatsappLink()} target="_blank" rel="noreferrer" className="mt-6 flex h-12 items-center justify-center rounded-full bg-white text-sm font-medium text-mauve-deep transition-colors duration-150 ease-smooth hover:bg-petal" data-id="element-468" data-mp="2a5a5xoljtsmu">
                {f.stillHelpCta}
              </a>
            </div>
          </aside>
        </div>
      </section>
    </main>;
}